import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GTMService } from '@services';
import { NoteStore } from '@store';

import { NoteService } from '../../../../+installations/services/note.service';

@Component({
  selector: 'app-note-card',
  templateUrl: './note-card.component.html',
  styleUrls: ['./note-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteCardComponent implements OnInit {
  installationId: string;
  showFullNote: boolean;

  constructor(
    public noteService: NoteService,
    public noteStore: NoteStore,
    private activatedRoute: ActivatedRoute,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param) => {
      this.installationId = param['id'];
    });
  }

  toggleShowFullNote(): void {
    this.showFullNote = !this.showFullNote;
  }

  showNoteModal(note: string): void {
    this.noteService.showNoteModal(this.installationId, note);
  }

  deleteNote(): void {
    this.noteStore.deleteNote(this.installationId);
    this.gtmService.track('onConfirm', 'Delete note', 'notePanel');
  }

  cancelDeleteModalConfirmation(): void {
    this.gtmService.track('onCancel', 'Delete note confirmation', 'notePanel');
  }
}
